import { ApiBase } from "@/api/ApiBase";

export type RegimeIva = "Geral" | "Simplificado" | "Exclusao";
export type Genero = "M" | "F" | "Indefinido";
export type EstadoCivil =
  | "Solteiro"
  | "Casado"
  | "Divorciado"
  | "Viuvo"
  | "Indefinido";
export type TipoDocIdentidade = "BI" | "Passaporte" | "Indefinido";

export interface PerfilComerciante {
  nome: string;
  codigo: string;
  nif: string;
  tipo: "Empresa" | "Particular";
  regimeIva: RegimeIva | null;
  provincia: string;
  municipio: string;
  endereco: string | null;
  website: string | null;
  telefone: string;
  email: string;
  logo: string | null;
  bannerEcraClientePOS: string | null;
  dataCriacao: string;
  genero: Genero | null;
  estadoCivil: EstadoCivil | null;
  dataNascimento: string | null;
  numeroDocIdentidade: string | null;
  tipoDocIdentidade: TipoDocIdentidade | null;
}

export interface DadosEdicaoComerciante {
  nome: string;
  nif: string;
  regimeIva: RegimeIva;
  genero: Genero | null;
  estadoCivil: EstadoCivil | null;
  dataNascimento: string | null;
  numeroDocIdentidade: string | null;
  tipoDocIdentidade: TipoDocIdentidade | null;
  telefone: string;
  email: string;
  website: string;
  provincia: string;
  municipio: string;
  endereco: string;
}

export interface EditarComercianteResponse {
  msg: string;
  tipo: "sucesso" | "erro";
}

export class DadosComercianteApi extends ApiBase {
  perfil(): Promise<PerfilComerciante> {
    return this.http.put<PerfilComerciante>("/api/comerciante/perfil");
  }

  editar(
    dados: DadosEdicaoComerciante,
    logo: File | null,
    bannerEcraClientePOS: File | null = null,
  ): Promise<EditarComercianteResponse> {
    const fd = new FormData();
    fd.append("nome", dados.nome);
    fd.append("nif", dados.nif);
    fd.append("regimeIva", dados.regimeIva);
    if (dados.genero) fd.append("genero", dados.genero);
    if (dados.estadoCivil) fd.append("estadoCivil", dados.estadoCivil);
    if (dados.dataNascimento) fd.append("dataNasc", dados.dataNascimento);
    if (dados.numeroDocIdentidade)
      fd.append("numeroDocIdentidade", dados.numeroDocIdentidade);
    if (dados.tipoDocIdentidade)
      fd.append("tipoDocIdentidade", dados.tipoDocIdentidade);
    fd.append("telefone", dados.telefone);
    fd.append("email", dados.email);
    fd.append("website", dados.website);
    fd.append("provincia", dados.provincia);
    fd.append("municipio", dados.municipio);
    fd.append("endereco", dados.endereco);
    if (logo) fd.append("logoComerciante", logo);
    if (bannerEcraClientePOS)
      fd.append("bannerComerciante", bannerEcraClientePOS);

    return this.http.postMultipart<EditarComercianteResponse>(
      "/api/comerciante/editar",
      fd,
    );
  }
}
